import { TableCell } from '@mui/material';
import moneyFormat from '../functions/moneyFormat';
import rateFormat from '../functions/rateFormat';
import displayDateTime from '../functions/displayDateTime';

const WorkflowAggregateRow = ({ row, count, tableHeader, rateTypeId=0, stickyEnabled}) => {

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return(
        <>
            {/* {tableHeader.map(el =>
                // logic to apply money format to correct rows
                el['columnname'] == 'cyclenetspend' || el['columnname'] == 'cyclenetinterchange' || el['columnname'] == 'cycleincentiveamount' ?
                    <> 
                        {row[el['columnname']] == null ?
                            <TableCell className={getRowClassName(el['columnorder'])} align='right'>None</TableCell>
                        :<TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>}
                    </>
                : el['columnname'] == 'blank' ?
                <TableCell className={getRowClassName(el['columnorder'])}></TableCell>
                // standard display for other cols
                : <> {row[el['columnname']] == null ?
                        <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>}
                </>
            )} */}
            { tableHeader.map(el =>
                el['format'] == 'blank' ?
                    <TableCell className={getRowClassName(el['columnorder'])}></TableCell> 
                : el['format'] == 'money' ? 
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>
                : el['format'] == 'rate' ?
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{rateFormat(row[el['columnname']], rateTypeId)}</TableCell>
                : el['format'] == 'date' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{displayDateTime(row[el['columnname']], true, false)}</TableCell>
                : el['format'] == 'date_ovr_offset' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{displayDateTime(row[el['columnname']], true, true)}</TableCell>
                // standard display for other columns 
                : row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                : <TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
            )}
        </>
    );
}

export default WorkflowAggregateRow;